function f(v) {
  return v < 10 ? `0${v}` : v;
}

export default (ts) => {
  const date = new Date(ts);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${f(day)}/${f(month)} à ${f(hours)}:${f(minutes)}`;
};
